import { Button, message } from 'antd';
import { useEffect } from 'react';

import { getUseShopQuoteStoreByCode, LK_SELECTED_COUPON_CODE } from '@/stores';

import {
  CreateFreeOrderParams,
  get,
  getTenantIdFromGConfig,
  getUfcShopComposedApi,
  i18nFormat,
  useProfileStore,
} from '@unionfab/ufc-shop-commons';
import styles from './index.module.less';
export const FreeOrderSubmitBtn = ({
  orderCode,
  canPay,
  onCreatePayOrder,
}: {
  orderCode: string;
  canPay: boolean;
  onCreatePayOrder?: (orderCode: string) => void;
}) => {
  const useShopQuoteStore = getUseShopQuoteStoreByCode(orderCode);
  const { accountInfo, loadPersonInfo } = useProfileStore(s => ({
    accountInfo: s.accountInfo,
    loadPersonInfo: s.loadPersonInfo,
  }));
  const useShopOrderStore = getUseShopQuoteStoreByCode(orderCode);

  const { couponCode } = useShopOrderStore(s => ({
    order: s.shopOrder,
    couponCode: s.couponCode,
    billingAddress: s.billingAddress,
    isWaitingUserPay: s.isWaitingUserPay,
    oceanpaymentPayUrl: s.oceanpaymentPayUrl,
  }));

  useEffect(() => {
    !accountInfo && loadPersonInfo();
  }, [accountInfo]);

  const pay = async () => {
    const antdMessageKey = 'create_order';

    try {
      message.loading({
        content: i18nFormat('Creating order'),
        key: antdMessageKey,
      });

      const tenantId = getTenantIdFromGConfig();

      const options: CreateFreeOrderParams = {
        couponCode,
      };
      const { status } =
        await getUfcShopComposedApi().ufcPaymentApi.createFreeOrder({
          tenantId,
          orderCode,
          options,
        });

      typeof onCreatePayOrder == 'function' &&
        status == 'ok' &&
        onCreatePayOrder(orderCode);

      useShopQuoteStore.setState({ isWaitingUserPay: true });

      if (!status) {
        useShopQuoteStore.setState({
          paymentResult: {
            success: false,
            failureMessage:
              'Error creating pay order, refresh and try again, or contact our customer service for help',
          },
        });
        return '';
      }

      return status;
    } catch (e) {
      const paymentResult = {
        success: false,
        failureMessage: '',
      };
      paymentResult.failureMessage =
        'Error creating pay order, refresh and try again, or contact our customer service for help';
      useShopQuoteStore.setState({ paymentResult });

      return '';
    }
  };
  return (
    <Button
      className={styles.payBtn}
      type="primary"
      disabled={!canPay || !accountInfo}
      onClick={pay}
    >
      {i18nFormat('Continue Your Free Order')}
    </Button>
  );
};
